module.exports = __webpack_public_path__ + "static/media/noto-sans-kr-v8-korean-Thin.bbb5b9c9.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/noto-sans-kr/noto-sans-kr-v8-korean-Thin.woff
// module id = 755
// module chunks = 0